const HOURS = Array.from({ length: 24 }, (_, index) => String(index).padStart(2, "0"));
const MINUTES = Array.from({ length: 12 }, (_, index) => String(index * 5).padStart(2, "0"));

export function FiveMinuteTimeField({
  label,
  value,
  onChange,
  disabled = false
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}): React.JSX.Element {
  const [hour = "00", minute = "00"] = value.split(":");
  return (
    <fieldset className="field five-minute-field" disabled={disabled}>
      <legend>{label}</legend>
      <div className="time-select-row">
        <label>
          <span className="visually-hidden">{label}小时</span>
          <select
            aria-label={`${label}小时`}
            value={HOURS.includes(hour) ? hour : "00"}
            onChange={(event) => onChange(`${event.target.value}:${minute}`)}
          >
            {HOURS.map((option) => (
              <option value={option} key={option}>{option}</option>
            ))}
          </select>
        </label>
        <span aria-hidden="true">:</span>
        <label>
          <span className="visually-hidden">{label}分钟</span>
          <select
            aria-label={`${label}分钟`}
            value={MINUTES.includes(minute) ? minute : "00"}
            onChange={(event) => onChange(`${hour}:${event.target.value}`)}
          >
            {MINUTES.map((option) => (
              <option value={option} key={option}>{option}</option>
            ))}
          </select>
        </label>
      </div>
    </fieldset>
  );
}
